interface ITypography {
  fontSize: string;
  fontFamily: string;
  lineHeight: string;
}

/**
 * 타이포 스케일 — 카리면접 정렬 정리(체크포인트-디자인).
 * 기존의 애매한 크기(25·21·19·17·15·13·11)를 사람이 보기 편한 깔끔한 짝수 스케일로 통일했다.
 *   28 / 24 / 22 / 20 / 18 / 16 / 14 / 12  (line-height 1.5 유지)
 * 키·폰트패밀리는 그대로라 520여 개 사용처가 자동으로 통일된 크기를 따른다.
 */
const typography: { [key: string]: ITypography } = {
  heading1Bold: {
    fontSize: "28px",
    fontFamily: "Pretendard Bold",
    lineHeight: "1.4",
  },
  heading1SemiBold: {
    fontSize: "28px",
    fontFamily: "Pretendard SemiBold",
    lineHeight: "1.4",
  },
  heading3SemiBold: {
    fontSize: "22px",
    fontFamily: "Pretendard SemiBold",
    lineHeight: "1.45",
  },
  heading4SemiBold: {
    fontSize: "20px",
    fontFamily: "Pretendard SemiBold",
    lineHeight: "1.45",
  },
  title1Bold: {
    fontSize: "24px",
    fontFamily: "Pretendard Bold",
    lineHeight: "1.45",
  },
  title1SemiBold: {
    fontSize: "24px",
    fontFamily: "Pretendard SemiBold",
    lineHeight: "1.45",
  },
  title2Bold: {
    fontSize: "20px",
    fontFamily: "Pretendard Bold",
    lineHeight: "1.45",
  },
  title2SemiBold: {
    fontSize: "20px",
    fontFamily: "Pretendard SemiBold",
    lineHeight: "1.45",
  },
  title3Bold: {
    fontSize: "18px",
    fontFamily: "Pretendard Bold",
    lineHeight: "1.5",
  },
  title3SemiBold: {
    fontSize: "18px",
    fontFamily: "Pretendard SemiBold",
    lineHeight: "1.5",
  },
  title4SemiBold: {
    fontSize: "16px",
    fontFamily: "Pretendard SemiBold",
    lineHeight: "1.5",
  },
  title4Bold: {
    fontSize: "16px",
    fontFamily: "Pretendard Bold",
    lineHeight: "1.5",
  },
  body1SemiBold: {
    fontSize: "18px",
    fontFamily: "Pretendard SemiBold",
    lineHeight: "1.5",
  },
  body1Medium: {
    fontSize: "18px",
    fontFamily: "Pretendard Medium",
    lineHeight: "1.5",
  },
  body1Regular: {
    fontSize: "18px",
    fontFamily: "Pretendard Regular",
    lineHeight: "1.5",
  },
  body2SemiBold: {
    fontSize: "16px",
    fontFamily: "Pretendard SemiBold",
    lineHeight: "1.5",
  },
  body2Medium: {
    fontSize: "16px",
    fontFamily: "Pretendard Medium",
    lineHeight: "1.5",
  },
  body2Regular: {
    fontSize: "16px",
    fontFamily: "Pretendard Regular",
    lineHeight: "1.5",
  },
  body3SemiBold: {
    fontSize: "14px",
    fontFamily: "Pretendard SemiBold",
    lineHeight: "1.5",
  },
  body3Medium: {
    fontSize: "14px",
    fontFamily: "Pretendard Medium",
    lineHeight: "1.5",
  },
  body3Regular: {
    fontSize: "14px",
    fontFamily: "Pretendard Regular",
    lineHeight: "1.5",
  },
  detail1Regular: {
    fontSize: "14px",
    fontFamily: "Pretendard Regular",
    lineHeight: "1.5",
  },
  detail2Regular: {
    fontSize: "12px",
    fontFamily: "Pretendard Regular",
    lineHeight: "1.5",
  },
  detail2Medium: {
    fontSize: "12px",
    fontFamily: "Pretendard Medium",
    lineHeight: "1.5",
  },
  label1SemiBold: {
    fontSize: "18px",
    fontFamily: "Pretendard SemiBold",
    lineHeight: "1.5",
  },
  label1Medium: {
    fontSize: "18px",
    fontFamily: "Pretendard Medium",
    lineHeight: "1.5",
  },
  label1Regular: {
    fontSize: "18px",
    fontFamily: "Pretendard Regular",
    lineHeight: "1.5",
  },
  label2SemiBold: {
    fontSize: "16px",
    fontFamily: "Pretendard SemiBold",
    lineHeight: "1.5",
  },
  label2Medium: {
    fontSize: "16px",
    fontFamily: "Pretendard Medium",
    lineHeight: "1.5",
  },
  label2Regular: {
    fontSize: "16px",
    fontFamily: "Pretendard Regular",
    lineHeight: "1.5",
  },
  label3SemiBold: {
    fontSize: "14px",
    fontFamily: "Pretendard SemiBold",
    lineHeight: "1.5",
  },
  label3Medium: {
    fontSize: "14px",
    fontFamily: "Pretendard Medium",
    lineHeight: "1.5",
  },
  label3Regular: {
    fontSize: "14px",
    fontFamily: "Pretendard Regular",
    lineHeight: "1.5",
  },
  label4SemiBold: {
    fontSize: "12px",
    fontFamily: "Pretendard SemiBold",
    lineHeight: "1.5",
  },
  label4Medium: {
    fontSize: "12px",
    fontFamily: "Pretendard Medium",
    lineHeight: "1.5",
  },
  label4Regular: {
    fontSize: "12px",
    fontFamily: "Pretendard Regular",
    lineHeight: "1.5",
  },
  label5SemiBold: {
    fontSize: "12px",
    fontFamily: "Pretendard SemiBold",
    lineHeight: "1.5",
  },
  label5Medium: {
    fontSize: "12px",
    fontFamily: "Pretendard Medium",
    lineHeight: "1.5",
  },
  label5Regular: {
    fontSize: "12px",
    fontFamily: "Pretendard Regular",
    lineHeight: "1.5",
  },
  sofiaProSemiBold: {
    fontSize: "14px",
    fontFamily: "SofiaPro SemiBold",
    lineHeight: "1.5",
  },
};

export default typography;
